export default __webpack_public_path__ + "static/media/activeListView.457b48ef.svg";